export default [
    {
        // [0]
        key: "empleado",
        label: "Empleado",
        visible: true,
    },
    {
        // [1]
        key: "fecha_inicio",
        label: "Fecha de Ingreso",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [2]
        key: "dias_laborados",
        label: "Dias Laborados",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "dias_acumulados",
        label: "Días Acumulados",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "dias_tomados",
        label: "Días Tomados",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [5]
        key: "dias_pagados_no_tomados",
        label: "Días Pagados No Tomados",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [6]
        key: "dias_restantes",
        label: "Días Restantes",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [7]
        key: "dias_programados",
        label: "Días Programados",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [8]
        key: "actions",
        label: "Acciones",
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]